
  import { defineComponent } from 'vue';
  import { Tooltip } from '@/ui/components/Tooltip';

  interface PhotoButtonProps {
    containsPhotos: boolean;
    classes: string | Record<string, boolean>;
  }

  export default defineComponent<PhotoButtonProps>({
    components: {
      Tooltip,
    },
    props: ['containsPhotos', 'classes'],
    emits: ['click'],
  });
